import CouponSetup from "@commons/coupon-setup";
import React from "react";

const StoreCouponSetup = () => {
  return <CouponSetup role="store" />;
};

export default StoreCouponSetup;
